/**
 * @generated SignedSource<<0d1b0d115eb9f4b2e2d51afdf1fc2b1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetailsSeller_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCallDealerCta_user" | "usePdpSellerDetails_user">;
  readonly " $fragmentType": "PdpRespSidebarDetailsSeller_user";
};
export type PdpRespSidebarDetailsSeller_user$key = {
  readonly " $data"?: PdpRespSidebarDetailsSeller_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsSeller_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetailsSeller_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpSellerDetails_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "111a8d17265ffa0202b956d77d890ede";

export default node;
